import { useState } from 'react';
import { Btn } from '@l2u/ui/components/Btn.tsx';
import { DateField } from '@l2u/ui/components/DateField.tsx';
import { toDateInput } from '@l2u/ui/lib/expiry.ts';

/**
 * Inline editor for a submitted file's expiry date (admin vendor detail).
 * Clear is offered only when the question does not require an expiry —
 * mirrors the server rule (the admin file PATCH rejects a null expiry on
 * requires_expiry questions) so the admin is never offered an action the API
 * will refuse. `onSave` receives the raw `YYYY-MM-DD` input value; the caller
 * serialises it with fromDateInput so an admin-typed date matches one
 * attached at upload time exactly.
 */
export function ExpiryEditor({
  initialExpiresAt,
  requiresExpiry,
  saving,
  onSave,
  onClear,
  onCancel,
}: {
  initialExpiresAt: string | null;
  requiresExpiry: boolean;
  saving: boolean;
  onSave: (dateInput: string) => void;
  onClear: () => void;
  onCancel: () => void;
}) {
  const [value, setValue] = useState(() => toDateInput(initialExpiresAt));
  return (
    <span className="inline-flex items-center gap-1.5">
      <DateField value={value} onChange={setValue} disabled={saving} ariaLabel="Expiry date" />
      <Btn size="sm" onClick={() => onSave(value)} disabled={value === ''} loading={saving}>
        Save
      </Btn>
      {!requiresExpiry && (
        <Btn size="sm" variant="secondary" onClick={onClear} disabled={saving}>
          Clear
        </Btn>
      )}
      <Btn size="sm" variant="ghost" onClick={onCancel} disabled={saving}>
        Cancel
      </Btn>
    </span>
  );
}
